var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7105 14.6934C12.523 14.8809 12.2687 14.9862 12.0035 14.9862C11.7383 14.9862 11.484 14.8809 11.2965 14.6934L6.7035 10.1004C6.52093 9.91412 6.41926 9.66331 6.42058 9.40248C6.4219 9.14165 6.5261 8.89188 6.71053 8.70744C6.89497 8.52301 7.14474 8.41881 7.40557 8.41749C7.6664 8.41618 7.91721 8.51784 8.1035 8.70041L12.0035 12.6004L15.9035 8.70041C16.0898 8.51785 16.3406 8.41618 16.6014 8.41749C16.8623 8.41881 17.112 8.52301 17.2965 8.70744C17.4809 8.89188 17.5851 9.14165 17.5864 9.40248C17.5877 9.66331 17.4861 9.91412 17.3035 10.1004L12.7105 14.6934Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.279c239c6a94585414ea9dbb581f777e.svg";
export { ForwardRef as ReactComponent };